import React, { type AnchorHTMLAttributes, type Ref } from "react";

import { cn } from "@virtual-brain-lib/frontend-design-system/utils";

export interface ExternalLinkProps extends Omit<
	AnchorHTMLAttributes<HTMLAnchorElement>,
	"href" | "target" | "rel"
> {
	readonly href: string;
	readonly ref?: Ref<HTMLAnchorElement>;
}

export function ExternalLink({ href, className, children, ref, ...props }: ExternalLinkProps) {
	return (
		<a
			{...props}
			ref={ref}
			className={cn("transition-colors", className)}
			href={href}
			rel="noreferrer noopener"
			target="_blank"
		>
			{children}
		</a>
	);
}
